// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/tsb-occurrence-reporting-channels.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/tsb-occurrence-reporting-channels/tsb-evidence-preservation.js';
import g1 from '../lessons/air-law/tsb-occurrence-reporting-channels/tsb-investigation-mandate.js';
import g2 from '../lessons/air-law/tsb-occurrence-reporting-channels/tsb-occurrence-reporting-channels.js';

mount([g0, g1, g2]);
